import Vue from "vue";
export var PreventDialogEventBus = new Vue();